const INITIAL_STATE = {
  data: [],
  count: 0,
  loading: false
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "GET_USER_ENGAGEMENT": {
      return {
        ...state,
        data: action.data,
        loading: false
      }
    }
    case "GET_BADGE_REPORT": {
      return {
        ...state,
        data: action.data,
        count: action.count,
        loading: false
      }
    }
    default:
      return state
  }
}
